import { useControls } from "leva"
import { ModelListPK } from "./Utils/ModelsList.js"
import { Suspense } from "react";
import ModelsSetup from "./Utils/ModelsSetup.js";
import AssayLoader from "./Utils/AssayLoader.js";
import HoleRender from "../holeTools/HoleRender.js";


export default function SabiModels() {
    const name_ = 'SabiModels'
    const {visible} = useControls(name_, {visible:false});
    
    console.log('Sabi Models rerendered')
    return (
        <>
        
        { visible && 
            <group>
                <AssayLoader/>
                <HoleRender/>
               {ModelListPK.map((model) => (
                    <Suspense fallback={null} key={model.name}>
                        <ModelsSetup group_={name_} name_={model.name} models={model.models} />                        
                    </Suspense>
                ))}
            </group>
            
        }
        </>
    )
}
